<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9">
      <div class="col-12 mb-3 mb-xl-0">
        <div class="card shadow">
          <div class="card-header d-xl-flex justify-content-between">
            <h3 class="m-0">Solicitudes de Muestrarios</h3>
            <div>
              <base-button @click="modals.newSwatchBook = true" size="sm" icon="fa fa-plus">
                Solicitar Muestrario
              </base-button>
            </div>
          </div>
          <ag-grid-vue 
            v-bind="agSwatchBooks" 
            ref="agSwatchBooks" 
            style="height: 65vh;"
            class="ag-theme-alpine" 
            @cell-clicked="onCellClicked"
            @row-double-clicked="onRowDoubleClicked"
          />
        </div>
      </div>
    </div>

    <modal :show.sync="modals.newSwatchBook" modal-classes="modal-dialog-centered modal-new-swatch-book">
      <NewSwatchBook 
        v-if="modals.newSwatchBook" 
        @close="modals.newSwatchBook = false"
        @success="getSwatchBooks()"
        />
    </modal>

    <modal :show.sync="modals.swatchBook" modal-classes="modal-dialog-centered modal-new-swatch-book" @close="onClose">
      <SwatchBook
        v-if="modals.swatchBook" 
        :sb="current"
        @close="modals.swatchBook = false; onClose()"
        @success="reOpen()"
      />
    </modal>

  </div>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import SwatchBook from "./SwatchBook.vue";
import NewSwatchBook from "./NewSwatchBook.vue";
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import BaseLoader from "@/components/BaseLoader.vue";
import EmptySection from "@/components/EmptySection.vue";
import { AgGridVue } from "ag-grid-vue";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import moment from 'moment';
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";
import AgGrid from "@/mixins/AgGrid.js";
import swatchBookStatus from "@/data/swatchBookStatus";
import AgBadge from "@/components/AgGrid/AgBadge.vue";

export default {
  mixins: [AgGrid],
  components: {
    SwatchBook,
    NewSwatchBook,
    BaseLoader,
    EmptySection,
    AgGridVue,
    agDateInput: FilterDate,
    AgBadge,
  },
  data() {
    return {
      current: null, 
      modals: {
        newSwatchBook: false,
        swatchBook: false,
      },
      agSwatchBooks: {
        rowData: null,
        columnDefs: [
          {
            headerName: "ID",
            field: "id",
            filter: "agTextColumnFilter",
            cellClass: "ag-clickable-cell text-blue font-weight-bold",
          },
          {
            headerName: "Tipo(s)",
            valueGetter: (params) => params.data.types.map(x => x.type).join(", ").substring(0, 50),
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Fecha de llegada",
            field: "estimatedDate",
            filter: "agDateColumnFilter",
            sort: "desc",
            filterParams: {
              comparator: this.dateFilterComparator,
            },
          },
          {
            headerName: "Fecha de solicitud",
            field: "createdDate",
            filter: "agDateColumnFilter",
            filterParams: {
              comparator: this.dateFilterComparator,
            },
          },
          {
            headerName: "Solicitante",
            field: "user",
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Estatus",
            field: "status",
            filter: "agSetColumnFilter",
            filterParams: {
              values: swatchBookStatus.map((s) => s.name),
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
            },
            cellRendererSelector: ({value}) => {
              const status = swatchBookStatus.find((s) => s.name === value);
              if (!status) return null;
							return {
								component: "AgBadge",
								params: {
									color: status.color
								}
							}
						}
          }
        ],
        defaultColDef: {
          suppressHeaderMenuButton: true,
          resizable: true,
          filter: true, 
          floatingFilter: true,
        },
        autoSizeStrategy: {
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        },
        readOnlyEdit:true,
        stopEditingWhenCellsLoseFocus:true,
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
        loadingOverlayComponent: "BaseLoader",
        noRowsOverlayComponent: "EmptySection",
        rowSelection: "single",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        alwaysShowVerticalScroll: true,
        localeText: AG_GRID_LOCALE_ES,
      },
    };
  },
  created(){
    this.getSwatchBooks();
    if(this.$route.hash){
      const hash = this.$route.hash.substring(1);
      if(this.agSwatchBooks.rowData){
        const sb = this.findById(hash);
        this.openSwatchBook(sb);
      } else {
        this.watcher = this.$watch('agSwatchBooks.rowData', (newValue) => {
          if(newValue){
            const sb = this.findById(hash);
            if(sb){
              this.openSwatchBook(sb);
            } else {
              this.$router.push({ hash: '' });
            }
            this.watcher();
          }
        });
      }
    }
  },
  methods: {
    getSwatchBooks(openId) {
      const db = getFirestore();
      const coll = collection(db, "swatch_book_requests")
      getDocs(coll).then((snapshot) => {
        if (!snapshot.empty) {
          this.agSwatchBooks.rowData = snapshot.docs
          .map((doc) => {
            return {
              ...doc.data(),
              id: doc.id,
              createdDate: moment.unix(doc.data().createdDate.seconds).format('YYYY-MM-DD'),
              estimatedDate: moment.unix(doc.data().estimatedDate.seconds).format('YYYY-MM-DD'),
            };
          })
          // console.log("ROWDATA", this.agSwatchBooks.rowData)
          if(openId){
            this.openSwatchBook(this.findById(openId));
          }
        } else {
          this.agSwatchBooks.rowData = [];
        }
      });
    },
    onRowDoubleClicked({data}) {
      this.openSwatchBook(data);
    },
    onCellClicked({data, colDef}) {
      if (colDef.field === "id") {
        this.openSwatchBook(data);
      }
    },
    findById(id) {
      return this.agSwatchBooks.rowData.find((item) => item.id === id);
    },
    openSwatchBook(data) {
      this.$router.push({ hash: `#${data.id}` });
      this.current = data;
      this.modals.swatchBook = true;
    },
    onClose(){
      this.current = null;
      this.$router.push({ hash: '' });
    },
    reOpen(){
      this.modals.swatchBook = false;
      this.getSwatchBooks(this.current.id); 
    }
  },
};
</script>
<style >
.modal-new-swatch-book {
  max-width: 600px;
}
.ag-clickable-cell {
  cursor: pointer;
}
.ag-clickable-cell:hover {
  background: #e9ecef;
}
</style>
